import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="candidate-vacancies"
export default class extends Controller {
  submit(event) {
    const form = event.currentTarget.closest('form')

    if (form) {
      form.requestSubmit()
    }
  }
}
